module.exports = __webpack_public_path__ + "img/ewe-go-ic.465c95c9.png";